export default "__VITE_ASSET__Bw$JFowG__"